import {createSvgIcon} from '../create-svg-icon';

export const AlignHorizontalLeftIcon = createSvgIcon(
  <path d="M4 22H2V2h2v20zM22 7H6v3h16V7zm-6 7H6v3h10v-3z" />
, 'AlignHorizontalLeftOutlined');
